import { gql } from '@apollo/client';

export const GET_BAG_SHIPMENT_HISTORY = gql`
    query GetBagShipmentHistory($bagNumber: String!) {
        bagShipmentHistory(bagNumber: $bagNumber) {
            id
            kind
            occurredAt
            operatorName
            operatorRole
            warehouseName
            parcelCount
            oldSortingRule
            newSortingRule
            failMessageKey
            originalScanType
        }
    }
`;

export type BagShipmentNodeKind =
    | 'CREATED'
    | 'DEPARTURE_SCAN'
    | 'BAG_RESHIP'
    | 'LOG_SCAN'
    | 'CURRENT';

export interface BagShipmentNodeType {
    id: string;
    kind: BagShipmentNodeKind;
    occurredAt: string;
    operatorName: string | null;
    operatorRole: string | null;
    warehouseName: string | null;
    parcelCount: number | null;
    oldSortingRule: string | null;
    newSortingRule: string | null;
    /** 失败原因 i18n key；仅 LOG_SCAN 节点非空 */
    failMessageKey: string | null;
    /** 原本要执行的扫描类型（如 BagReship）；仅 LOG_SCAN 节点非空 */
    originalScanType: string | null;
}

export interface GetBagShipmentHistoryResponse {
    bagShipmentHistory: BagShipmentNodeType[];
}

export interface GetBagShipmentHistoryVariables {
    bagNumber: string;
}
